import React from "react";
import { DateRangePicker } from "@heroui/react";
import { CalendarDate } from "@internationalized/date";

interface AvailableDaysSelectorProps {
    t: any;
    availableDays: string[];
    dateRange: { start: CalendarDate | null; end: CalendarDate | null };
    handleDateRangeChange: (range: { start: CalendarDate; end: CalendarDate } | null) => void;
    errors: any;
    today: (timeZone: string) => CalendarDate;
    getLocalTimeZone: () => string;
}

const AvailableDaysSelector: React.FC<AvailableDaysSelectorProps> = ({
    t,
    availableDays,
    dateRange,
    handleDateRangeChange,
    errors,
    today,
    getLocalTimeZone,
}) => {
    return (
        <div className="space-y-2 align-items-center">
            <div className="flex items-center justify-between">
                <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                    {t("available_days")}
                </h3>
                {availableDays.length > 0 && (
                    <div className="text-sm font-medium text-blue-600 bg-blue-50 px-2 py-0 rounded">
                        {availableDays.length} {t('dates')}
                        {availableDays.length > 1 ? "s" : ""} {t('selected')}
                    </div>
                )}
            </div>
            <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600 block">
                    <div className="flex items-center gap-1">
                        {t("select_date_range")}

                    </div>
                </label>
                <DateRangePicker
                    value={dateRange.start && dateRange.end ? { start: dateRange.start, end: dateRange.end } : null}
                    onChange={handleDateRangeChange}
                    minValue={today(getLocalTimeZone())}
                    size="sm"
                    className="w-full"
                    placeholderValue={today(getLocalTimeZone())}
                />
                {errors.availableDays && (
                    <div className="text-red-500 text-xs">
                        {errors.availableDays}
                    </div>
                )}
            </div>
            {dateRange.start && dateRange.end && (
                <div className="mt-2 p-2 bg-blue-50 rounded-lg border">
                    <div className="text-xs text-gray-600 mb-1">
                        {t("selected_range")}:
                    </div>
                    <div className="text-xs font-medium text-blue-700">
                        {dateRange.start.toString()} - {dateRange.end.toString()}
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                        {t("total_days")}: {availableDays.length}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AvailableDaysSelector;